/**
 * @fileoverview トップページ キービジュアル制御
 * @description KVイントロ・スクロール割り込み・スタッキングを管理
 */

const initKvIntro = () => {
	// トップページ以外では何もしない
	if (!document.body.classList.contains('home')) return;

	const kv = document.querySelector('.p-home-kv');
	const copy = kv?.querySelector('.p-home-kv__copy');
	if (!kv || !copy) return;

	let forced = false;

	/* ------------------------------
	 * 初期スクロール割り込み
	 * ------------------------------ */
	const onInitialScroll = () => {
		if (forced) return;
		forced = true;

		kv.classList.add('is-force', 'is-enter');
		copy.classList.add('is-visible');

		window.removeEventListener('scroll', onInitialScroll);
	};

	/* ------------------------------
	 * KVイントロ開始
	 * ------------------------------ */
	const startIntro = () => {
		requestAnimationFrame(() => {
			kv.classList.add('is-enter');

			setTimeout(() => {
				if (!forced) {
					copy.classList.add('is-visible');
				}
			}, 1000);
		});

		window.addEventListener('scroll', onInitialScroll, { passive: true });
	};

	/* ------------------------------
	 * is-loaded を待って開始
	 * ------------------------------ */
	const onReady = () => {
		startIntro();
		kvAreaStacking(kv);
	};

	if (document.documentElement.classList.contains('is-loaded')) {
		onReady();
	} else {
		const loadObserver = new MutationObserver(() => {
			if (document.documentElement.classList.contains('is-loaded')) {
				loadObserver.disconnect();
				onReady();
			}
		});

		loadObserver.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ['class'],
		});
	}
};

/* ------------------------------
 * KV専用 sticky スタッキング
 * ------------------------------ */
const kvAreaStacking = (kv) => {
	const area = kv.querySelector('.p-home-kv__copy');
	if (!area) return;

	const targets = Array.from(area.children);
	if (targets.length === 0) return;

	const checkPosition = () => {
		const heights = targets.map((target) => {
			target.style.paddingTop = '';
			target.style.paddingBottom = '';
			return target.offsetHeight;
		});

		const len = heights.length;

		targets.forEach((target, index) => {
			const topHeight =
				index > 0
					? heights.slice(0, index).reduce((a, x) => a + x, 0)
					: 0;

			target.style.paddingTop = `${topHeight}px`;

			if (index < len - 1) {
				const bottomHeight = heights
					.slice(index + 1)
					.reduce((a, x) => a + x, 0);

				target.style.paddingBottom = `${bottomHeight}px`;
			}
		});
	};

	checkPosition();

	const resizeObserver = new ResizeObserver(() => {
		checkPosition();
	});

	resizeObserver.observe(area);
};

document.addEventListener('DOMContentLoaded', initKvIntro);
